export default __webpack_public_path__ + "static/media/china_light.89fba9ac.png";